"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fuzzysearch_1 = __importDefault(require("fuzzysearch"));
var toLowerCaseString_1 = __importDefault(require("./toLowerCaseString"));
var fuzzy = function (needle, haystack) {
    needle = toLowerCaseString_1.default(needle).replace(/ /g, '');
    haystack = toLowerCaseString_1.default(haystack);
    return fuzzysearch_1.default(needle, haystack);
};
exports.default = fuzzy;
